<template>
  <div class="flex flex-col items-center">
    <div class="flex px-2 py-5 w-full bg-gray-800 relative">
      <span
        class="absolute top-0 right-0 mr-1 font-medium"
        :class="[
          text.length / maxChars < 0.9
            ? 'text-gray-600'
            : text.length / maxChars === 1
            ? 'text-red-600'
            : 'text-orange-600',
        ]"
      >
        {{ text.length }} / {{ maxChars }}
      </span>
      <img class="w-5 h-5" src="../../assets/icons/input.svg" alt="Entrez un nom pour le nouveau label" />
      <textarea
        v-model="text"
        class="px-2 w-full bg-gray-800 text-white focus:outline-none placeholder-gray-600 "
        placeholder="Votre contribution"
        :rows="maxChars === 30 ? 1 : maxChars === 120 ? 4 : 9"
        :maxlength="maxChars"
      />
    </div>
    <div class="w-full" v-if="labels.length > 1">
      <button
        v-for="(label, index) in labels"
        :key="label.guid_text"
        @click="
          newAnswer({ text: text, label_guid: label.guid_text })
          $emit('closeMenu')
        "
        class="font-light text-white text-base w-full py-3 focus:outline-none"
        :class="{ 'rounded-t-none rounded-lg pb-2': index === labels.length - 1 }"
        :style="
          'background-color:' + getLabelColors(label.guid_text).bg + '; color:' + getLabelColors(label.guid_text).font
        "
      >
        Envoyer dans {{ label.text }}
      </button>
    </div>
    <div class="w-full" v-else>
      <button
        @click="
          newAnswer({ text: text })
          $emit('closeMenu')
        "
        class="bg-green font-light text-white text-base w-full py-3 focus:outline-none rounded-t-none rounded-lg pb-2"
      >
        Valider
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex"

export default {
  data() {
    return {
      text: "",
    }
  },
  computed: {
    ...mapGetters("labels", ["getLabelColors"]),
    ...mapState({
      maxChars: (state) => state.question.max_chars,
      labels: (state) => state.labels.all,
    }),
  },
  methods: {
    ...mapActions("answers", ["newAnswer"]),
  },
}
</script>

<style></style>
